import { Component } from '@angular/core';

import { ShellComponent } from './shell/shell.component';

@Component({
  selector: 'app-root',
  imports: [ShellComponent],
  template: '<app-shell />',
  styleUrl: './app.component.scss'
})
export class AppComponent {
}

